<!-- Divider -->
<div
    class="fakturnia-vertical-navigation-item-wrapper divider"
    [ngClass]="item.classes?.wrapper"></div>
